module.exports={
    btn:{
        tips_reelect_btn:"新圖片",
        cancel_btn:"取消",
        tips_continue_dispose:"忽略不支持的文件",
        tips_return:"新圖片",
        tips_upgrade:"升級",
        tips_yes:"確定",
        delete:"刪除",
        download:"下載",
        upload_image:"上傳圖片",
        new_image:"新圖片",
        save_all:"保存全部",
        cancel:"取消",
        save:"保存",
        view_comparison:"查看比較",
        hide_comparison:"隱藏比較",
        previous:"上一張",
        next:"下一張",
        continue_download:"保存帶水印的圖片",
        present:"應用於此圖",
        all_wait:"應用於等待中的圖片",
        all:"應用於所有圖片",
        history:"歷史記錄",
        login:"登錄",
    },
    tips:{
        please_upgrade:"您當前的權益不支持批量處理。請升級後解鎖。",
        errorlistinfo:"共選擇XXX個文件。 XXX張圖片支持處理,XXX個文件不支持。以下是不受支持的文件:",
        max:"超過10MB的大小限制!",
        max_size:"超過最長邊4096px的尺寸限制!",
        continue_dispose:"忽略不支持的文件",
        please_multiple:"請選擇放大倍數",
        max_multiple:"*最高可將圖片放大至4K(最長邊不超過4096px)。",
        title:"文件名",
        reasons:"原因",
        upload_type:"格式不支持",
        used_up:"下載無水印高清圖片的次數已用完。請再次升級或下載帶水印的圖片。",
        edit_multiple:"您有多張圖片，請選擇修改的倍數將應用於哪些圖片。",
        download_confirm:"您有圖片未完成，確定保存當前所有已完成的圖片嗎？重複保存不會重複扣除次數。",
        waiting_save:"一些圖片還在處理中。請稍後保存。",
        
    },
    header:{
        title:"Aiseesoft在線圖像超分",
        hd:"次",
        watermarks:"無水印高清圖片次數可供消耗，",
        view_details:"查看詳情",
        loading:"加載中...",
    },
    content:{
        failed:"失敗",
        completed:"完成",
        processing:"處理中",
        img_processing:"處理中...",
        img_failed:"處理失敗",
        uploading:"上傳中",
        img_uploading:"上傳中...",
        wait_upoading:"等待上傳...",
        waiting:"等待中",
        img_waiting:"等待中...",
        empty:"空空如也",
        magnification:"放大倍數:",
        drop:"或拖拽圖片到這裡",
        original:"原圖:",
        output:"放大後:",
        img_rendering1:"圖片已超分完成",
        img_rendering2:"正在努力渲染高清大圖以供查看預覽，請稍等...",
        no_watermark:"圖片下載後為無水印版本",
    },
    banner_msg:"為圖片放大選擇一個計劃",
    monthly:"每月",
    lifetime:"終身",
    choose_plan:"根據圖像數量選擇您的計劃",
    return_home:"恭喜！您已成功升級。請返回首頁使用本產品",
    congratulations:"恭喜！您已成功升級。福利已與您升級時留下的郵箱綁定。請使用註冊或鏈接到電子郵件地址的帳戶",
    login_benefits:"登錄使用福利",
    no_registered:". 如果您還沒有註冊或鏈接到電子郵件地址的帳戶，請",
    register_account:"使用電子郵件地址註冊帳戶",
    other_accounts:"  或將其他帳戶鏈接到此電子郵件地址以使用福利。",
    btn_close:"關閉",
    free:"免費",
    btn_get_started:"開始吧",
    // access_to:"進入",
    upscale_images:"高檔圖片",
    up_to:"最高 ",
    per_image:"  每張圖片",
    resolution_of:"分辨率為 ",
    default_level:"默認級別的高檔圖像",
    image_downloads:"2張無水印高清圖片下載",
    unlimited_image:"帶水印的無限圖像下載",
    SHA256_encryption:"SHA256加密技術",
    mon:"每月",
    images:"圖片",
    high_resolution:"  具有高分辨率的質量",
    tax_incl:"含稅",
    image:"圖像",
    secure_checkout:"安全支付",
    everything:"一切都免費，而且",
    upscaling_levels:"可以選擇所有升級級別",
    unlimited_image_without:"無水印無限製圖像下載",
    viewable_editing:"可查看的編輯歷史適用於 ",
    days:"  天",
    high_level:"高水平",
    priority_processing:"  優先處理",
    left:"終身",
    resolution:"分辨率",


    "history_will":"將在之後過期",
    "history.days":"天",
    "history.hours":"小時",
    "expired":"已過期",
    "access_to":"通過免費試用，您只能",
    "pricing.upload_images":"上傳圖片",
    "pricing.under":"小於",
    "pricing.images":"張圖片",
    "pricing.without_watermark":"無水印",
    "pricing.process_images":"處理圖像高達",
    "pricing.pixels":"像素",
    "pricing.enjoy_limited":"訂閱權益可試用",
    "pricing.download":"可下載",
    "pricing.HD_images":"張無水印高清圖",
    "pricing.and_you":"您可能會遇到",
    "pricing.slow_upscaling":"長久等待",
    "pricing.lower_priority":"低優先級的問題",
    "pricing.without":"無水印",
    "pricing.tax":"稅費包含在銷售價格中，將根據您所在的國家和地區自動計算。在購物車中您可以看到詳細的稅額。您的最終付款金額應與顯示的價格相同。",
    "pricing.you_can":"通過訂閱，您可以",
    "pricing.up_to":"上傳圖片最大",
    "pricing.upscale_images":"放大圖像",
    "pricing.no_watermark":"無水印",
    "pricing.enhance":"可",
    "pricing.or_more":"張圖片或更多圖片",
    "pricing.in_batch":"批量處理",
    "pricing.enlarge_images":"享受圖像",
    "pricing.and":"和",
    "pricing.times_with":"放大，無次數限制",
    "pricing.enjoy":"享受",
    "pricing.of_history":"歷史存儲時間",
    "pricing.experience":"體驗",
    "pricing.fast_upscaling":"快速通道",
    "pricing.higher_priority":"更高的優先級",
    "pricing.early_access":"搶先體驗新功能",
    "pricing.cancel_anytime":"隨時取消",
    "pricing.lifetime_license":"通過終身買斷，您可以",
    "pricing.and_there":"而且額度",
    "pricing.no_expiration":"沒有有效期",
    "pricing.unless":"直到用盡",

    "buynow.pop.credit":"點",
    "buynow.pop.credits":"點",

    "isUnderequityTip_msg1":"您選擇了{%}張圖片進行批是處理，剩餘權益不足，還需{%}點（現時剩餘{%}點權益），如需處理請購買權益以繼續處理影像。",
    "isUnderequityTip_msg2":"您選擇了{%}張圖片進行批是處理，剩餘權益不足，還需{%}點（現時剩餘{%}張權益），如需處理請購買權益以繼續處理影像。",
    "isUnderequityTip_msg3":"您選擇了{%}張圖片進行批是處理，剩餘權益不足，還需{%}點（現時剩餘{%}點、{%}張權益），如需處理請購買權益以繼續處理影像。",
    "btn_buy_now":"立即購買",
    "isEquityDepletionTip_msg":"您當前的權益已經用盡，請購買權益以進行批次處理",

    "pricing.h1":"Aiseesoft AI Photo Editor - 計劃和定價",
    "pricing.banner_content":"獲取AI Photo Editor積分，用於線上或從桌面移除影像背景、放大影像以及從影像中移除物體。",
    "pricing.best_seller":"暢銷",
    "pricing.monthly":"月度訂閱",
    "pricing.credits":"積分",
    "pricing.lifetime":"終身",
    "pricing.note":"注意",
    "pricing.buy_now":"立即購買",
    "pricing.note_content":"購買的積分與您在購物車中輸入的電子郵件地址相關聯。要使用這些積分，請使用相同的電子郵件地址註冊或登入。",

    "header.buy_more":"購買更多",
    "header.available_credits":"可用積分",
    "header.credits":"積分"
}